export enum PayCodeType {
    Personal = 'PTO',
    Sick = 'SICK',
    Vacation = 'VAC',
    Regular = 'RT',
    Custom = 'CUSTOM',
    LeaveWithoutPay = 'LWOP',
    Bereavement = 'BREV',
    Overtime = 'OT',
    DoubleOverTime = 'DOT',
    SingleOverTime = "SOT",
    Holiday = 'HT',
    Hazard = 'HAZ',
    Jury = "JURY",
    HealthAndWelfare = "HANDW",
    Bonus = "BONUS",
    Military = "MILITARY",
    Fmla = "FMLA",
    Miscellanious = "MISC",
    Scavac = "SCAVAC",
}

export namespace PayCodeType {
  export function isWorkingPayType(payCodeType: PayCodeType): boolean {
    return payCodeType == PayCodeType.Regular || payCodeType == PayCodeType.Hazard || payCodeType == PayCodeType.Custom;
  }

  export function isOverTimePayType(payCodeType: PayCodeType): boolean {
    return payCodeType == PayCodeType.Overtime;
  }

  export function includeInPayPeriodEarningCalculation(payCodeType: PayCodeType): boolean {
    return payCodeType != PayCodeType.HealthAndWelfare && payCodeType != PayCodeType.Bonus && payCodeType != PayCodeType.Miscellanious;
  }
}
